import { render, staticRenderFns } from "./NoteFloatingButton.vue?vue&type=template&id=02e2dbe8&scoped=true"
import script from "./NoteFloatingButton.vue?vue&type=script&lang=js"
export * from "./NoteFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./NoteFloatingButton.vue?vue&type=style&index=0&id=02e2dbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e2dbe8",
  null
  
)

export default component.exports